var _path, _ellipse;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEye = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5439 6.88473C13.5439 6.88473 11.7335 10.5 7.82568 10.5C3.91788 10.5 2.10745 6.88473 2.10745 6.88473C2.06509 6.80051 2.06509 6.69948 2.10745 6.61527C2.10745 6.61527 3.91788 3 7.82568 3C11.7335 3 13.5439 6.61527 13.5439 6.61527C13.5863 6.69949 13.5863 6.80052 13.5439 6.88473ZM7.82568 4.15386C6.46568 4.15386 5.36143 5.31719 5.36143 6.74998C5.36143 8.18276 6.46568 9.34609 7.82568 9.34609C9.18569 9.34609 10.2899 8.18276 10.2899 6.74998C10.2899 5.31719 9.18569 4.15386 7.82568 4.15386Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.85071,
    cy: 6.7749,
    rx: 1.375,
    ry: 1.375,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye.297d8f16.svg";
export { ForwardRef as ReactComponent };